// extracted by mini-css-extract-plugin
export var quantityInput = "_ng-0";